import { getBankListProps } from "../BanksList/logic/logic";
import { getQRProps } from "../QRModal/logic/logic";
import { EPaymentMethod } from "../../../../../../dependencies/getContent/constants";
import { findFirst } from "../../../../../../../utils/arrays";
// Returns props for rendering SBP modal
export var getMapStateToSBPModalProps = function getMapStateToSBPModalProps(_ref) {
  var getIsMobile = _ref.getIsMobile,
    getSBPBanks = _ref.getSBPBanks,
    initializeSBPBanks = _ref.initializeSBPBanks,
    getContent = _ref.getContent,
    initializeQRCode = _ref.initializeQRCode,
    getQRCode = _ref.getQRCode,
    pollSbpStatus = _ref.pollSbpStatus;
  return function (getState, setState) {
    var _state$scenario, _state$scenario2;
    var state = getState();
    return findFirst([((_state$scenario = state.scenario) === null || _state$scenario === void 0 ? void 0 : _state$scenario.type) === EPaymentMethod.SBP && !(getIsMobile !== null && getIsMobile !== void 0 && getIsMobile()) && getQRProps({
      getContent: getContent,
      initializeQRCode: initializeQRCode,
      getQRCode: getQRCode,
      pollSbpStatus: pollSbpStatus
    })(getState, setState), ((_state$scenario2 = state.scenario) === null || _state$scenario2 === void 0 ? void 0 : _state$scenario2.type) === EPaymentMethod.SBP && !!(getIsMobile !== null && getIsMobile !== void 0 && getIsMobile()) && getBankListProps({
      getSBPBanks: getSBPBanks,
      initializeSBPBanks: initializeSBPBanks,
      initializeQRCode: initializeQRCode,
      pollSbpStatus: pollSbpStatus
    })(getState, setState)]);
  };
};